import { useInitialFocus } from "@skv/core";
import { OpportunitySearchResults } from "@skv/core/src/types";
import { OpportunitySearchQueryState } from "@skv/state";

interface OpportunitySearchResultsHeaderProps {
  searchResults: OpportunitySearchResults;
  searchQuery: OpportunitySearchQueryState;
}

export const OpportunitySearchResultsHeader = ({
  searchResults,
}: OpportunitySearchResultsHeaderProps) => {
  const foundRef = useInitialFocus<HTMLSpanElement>();

  return (
    <span
      ref={foundRef}
      tabIndex={-1}
      aria-live="polite"
      css={`
        &:focus-visible {
          outline: none;
        }
      `}
    >
      {searchResults.searchSummary}
    </span>
  );
};
